module.exports = __webpack_public_path__ + "assets/img/b5b13daf517c85105dba351c1785fbf0.svg";